import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { AppSettings } from "../../proyect.conf";
import { AutenticacionService } from './autenticacion.service';
import {PoliticaPerfil} from '../_models/politica-perfil';
import {PoliticaOficina} from '../_models/politica-oficina';

@Injectable({
  providedIn: "root",
})
export class PoliticasOficinaService {
  private rutServicio = AppSettings.rutServiciosPOLITICA + "/api/politicasOficinas";

  constructor(
    private httpClient: HttpClient,
    private autServicio: AutenticacionService
  ) {}

  listadoPoliticaOficina() {
    return this.httpClient
      .get(this.rutServicio)
      .pipe(map((res) => res as PoliticaOficina[]));
  }

  listadoPoliticaOficinaHabilitados() {
    return this.httpClient
      .get(this.rutServicio + "/enabled")
      .pipe(map((res) => res as PoliticaOficina[]));
  }

  obtenerPorId(id: string) {
    return this.httpClient
      .get(this.rutServicio + "/" + id)
      .pipe(map((res) => res as PoliticaOficina));
  }

  listadoIdPolitica(idPolitica: string) {
    return this.httpClient
      .get(this.rutServicio  + "/politica/" + idPolitica)
      .pipe(map((res) => res as PoliticaOficina[]));
  }

  listadoIdPoliticaEnabled(idPolitica: string) {
    return this.httpClient
      .get(this.rutServicio  + "/politica/" + idPolitica + "/enabled" )
      .pipe(map((res) => res as PoliticaOficina[]));
  }

  crear(regCrear: PoliticaOficina) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .post(this.rutServicio, regCrear)
      .pipe(map((res) => res as PoliticaOficina));
  }

  actualizar(regActualizar: PoliticaOficina) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .put(this.rutServicio, regActualizar)
      .pipe(map((res) => res as PoliticaOficina));
  }

  bulk(registros: PoliticaOficina[]) {
    registros.map((s: PoliticaOficina) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    });
    return this.httpClient
      .post(this.rutServicio + "/bulk", registros)
      .pipe(map((res) => res as PoliticaOficina[]));
  }
}
